import { Component, OnInit } from '@angular/core';
import { BPProfilesAuditDataService, IAuditLink } from './bp-profiles-audit-data.service';
import { BPProfilesService } from '../../bp-profiles.service';

@Component({
  selector: 'bp-profiles-audit',
  template: `
    <div>
      <li *ngFor="let link of links">
        <a [uiSref]="link.state" [uiParams]="link.stateParams" target="_blank">{{link.title}}</a>
      </li>
    </div>
  `
})
export class BPProfilesAuditComponent implements OnInit {
  public links:IAuditLink[];

  constructor(
    private bpProfilesAuditDataService:BPProfilesAuditDataService,
    private bpProfilesService:BPProfilesService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.links = this.bpProfilesAuditDataService.getAuditLinks(this.bpProfilesService.activeProfile?.companyCountryId, this.bpProfilesService.activeProfile?.company?.id);
  }
}